import ApiService from "./apiservice";

export const NotificationService = {
    GetSubscriptions(payload) {
        return ApiService.get("Notification/GetSubscriptions", payload);
    },
    SendNotification(params) {
        return ApiService.post("Notification/SendNotification", null, params);
    },
    SendNotificationForManager(params) {
        return ApiService.post("Notification/SendNotificationForManager", null, params);
    },
    AddSubscription(data) {
        return ApiService.post("Notification/AddSubscription", data);
    },
};